/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import { Component } from "react";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import styled from "styled-components";
import PropTypes from "prop-types";
import Theme from "../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledTopContainer = styled.div`
  background: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.5em;
  color: black;
  padding: 20px 0px 40px 0;
`;

const StyledMainContainer = styled.div`
  margin-top: 15px;
  background: white;
  align-self: stretch;
  padding: 0px 0px 0px 25px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const StyledSpaceBetweenContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px 18px 0;
  font-size: 1em;
  color: black;
  border-bottom: 1px solid lightgray;
`;

const StyledTopUpBtn = styled.div`
  margin-top: 25px;
  border-radius: 25px;
  width: 80%;
  color: white;
  background: ${Theme.PrimaryColor};
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  bottom: 10%;
`;

class TopUpSuccessfulPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animationClass: null,
      transactionId: 324532910,
      date: "27 Jan 2018 10:34",
      paymentMethod: "Credit/Master Card",
      amountPaid: "RM10"
    };
  }

  componentDidMount() {
    const { showTabbar, showNavbar } = this.props;

    showNavbar(false);
    showTabbar(false);
    this.setState({ animationClass: "slide-in-right" });
  }

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  render() {
    const {
      animationClass,
      transactionId,
      date,
      paymentMethod,
      amountPaid
    } = this.state;
    const { history } = this.props;

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        <StyledTopContainer>
          <img
            src={require("../../assets/success_banner.png")}
            alt=""
            style={{
              width: "60%"
            }}
            onLoad={() => {
              window.dispatchEvent(new Event("resize"));
            }}
          />
          <span>
            <FormattedMessage
              id="topup.wallet.successful.title"
              defaultMessage="Top-up Successfully"
              description="Top Up Wallet Successful Title"
            />
          </span>
        </StyledTopContainer>
        <StyledMainContainer>
          <StyledSpaceBetweenContainer>
            <span>
              <FormattedMessage
                id="topup.wallet.successful.transaction.title"
                defaultMessage="Transaction ID"
                description="Top Up Wallet Successful Transaction ID Title"
              />
            </span>
            <span>{transactionId}</span>
          </StyledSpaceBetweenContainer>
          <StyledSpaceBetweenContainer>
            <span>
              <FormattedMessage
                id="topup.wallet.successful.date.title"
                defaultMessage="Date"
                description="Top Up Wallet Successful Date Title"
              />
            </span>
            <span>{date}</span>
          </StyledSpaceBetweenContainer>
          <StyledSpaceBetweenContainer>
            <span>
              <FormattedMessage
                id="topup.wallet.successful.payment.method.title"
                defaultMessage="Payment Method"
                description="Top Up Wallet Successful Payment Method Title"
              />
            </span>
            <span>{paymentMethod}</span>
          </StyledSpaceBetweenContainer>
          <StyledSpaceBetweenContainer style={{ borderBottom: "unset" }}>
            <span>
              <FormattedMessage
                id="topup.wallet.successful.amount.paid.title"
                defaultMessage="Amount Paid"
                description="Top Up Wallet Successful Amount Paid Title"
              />
            </span>
            <span style={{ fontWeight: "bold" }}>{amountPaid}</span>
          </StyledSpaceBetweenContainer>
        </StyledMainContainer>
        <StyledTopUpBtn
          className={"opacity"}
          onClick={() => history.push("/shop/me")}
        >
          <FormattedMessage
            id="topup.wallet.successful.button.title"
            defaultMessage="Check My Balance Now"
            description="Top Up Wallet Successful Button Title"
          />
        </StyledTopUpBtn>
      </StyledContainer>
    );
  }
}

TopUpSuccessfulPage.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default injectIntl(TopUpSuccessfulPage);



// WEBPACK FOOTER //
// ./src/containers/TopUpSuccessfulPage/index.js